// extracted by mini-css-extract-plugin
module.exports = {"spacer":"_1SbmGboSMF-JvpaH-PJZ4W","switch":"_26-4AmiPw70Illlhuxg0Ni"};